import type { EnvironmentResponse, Environment } from '../types/environments';
import { APIClient } from './apiClient';
import { VL_API_BASE_URL } from 'vince-core/constants/backendUrls';

// TODO something strange with path here and in environment
const baseUrl = `${VL_API_BASE_URL}/environments`;


export async function loadEnvironments (fetchOptions?: Record<string, unknown>) {
    return await APIClient<EnvironmentResponse>(baseUrl, fetchOptions);
}

export async function loadEnvironmentsByIds (ids: string[], fetchOptions?: Record<string, unknown>) {
    const uniqueIds = [...new Set(ids.filter(Boolean))];
    if (!uniqueIds.length) {
        return { items: [], count: 0 } as EnvironmentResponse;
    }

    const idSet = new Set(uniqueIds);
    const response = await loadEnvironments(fetchOptions);
    const items = response.items.filter(environment => idSet.has(environment.environmentId));

    return {
        ...response,
        items,
        count: items.length
    };
}

export async function getEnvironmentById (envId: string, fetchOptions?: Record<string, unknown>) {
    const response = await APIClient<Environment>(`${baseUrl}/${envId}`, fetchOptions);
    return {
        ...response,
        theme: { bgColor: response.theme?.bgColor ?? '' }
    };
}
export async function createEnvironment (environmentData: Partial<Environment>) {
    return await APIClient<EnvironmentResponse>(baseUrl, {
        method: 'POST',
        body: JSON.stringify(environmentData)
    });
}
export async function updateEnvironment (environmentData: Partial<Environment>) {
    return await APIClient<EnvironmentResponse>(baseUrl, {
        method: 'PUT',
        body: JSON.stringify(environmentData)
    });
}
export async function deleteEnvironment (envId: string) :Promise<void> {
    await APIClient(`${baseUrl}/${envId}`, { method: 'DELETE' });
}
